import { ErrorHandler, inject, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import * as Sentry from "@sentry/angular";
import { EnvironmentService } from '../services/environment.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    private environmentService = inject(EnvironmentService);
    handleError(error: any): void {
        if (!(error instanceof HttpErrorResponse)) {
            console.error('An error occurred:', error);
            // Non-HTTP error: register with Sentry
            if (error instanceof Error) {
                 Sentry.captureException(error, {
                    tags: {
                        app_version: this.environmentService.env.appVersion,
                    }
                });
            } else {
                const customError = new Error('A non-Error object was captured');
                // Attach original data for context
                Sentry.captureException(customError,{
                      tags: {
                        app_version: this.environmentService.env.appVersion,
                    },
                    extra: {
                        'originalException': error
                    }
                });
            }           
        }
    }
}